export const virtualAgentTableOptions = {
  actionsColumnIndex: -1,
  draggable: false,
  grouping: false,
  headerStyle: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '32px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  padding: 'dense',
  paging: false,
  rowStyle: {
    fontSize: '14px',
    fontWeight: 400,
  },
  search: false,
  sorting: false,
  toolbar: false,
  maxBodyHeight: '65vh',
};
